module.exports = __webpack_public_path__ + "img/academy-biznes.5b457e1c.png";